import React from "react";
import { Formik, Field, Form } from "formik";
import {
  TextField,
  Loading,
  GalleryField,
  Select,
  PersianDataPicker,
  CheckBox,
} from "components/form";
import Modal from "components/Modal";
import { useCore } from "store/core";

export default function Edit({ show, close, title, submit, item }) {
  const core = useCore();

  const initialValues = {
    id: item?.id,
    title: item?.title ?? "",
    channel: item?.channel?.id || "",
    media: item?.media?.id ?? null,
    logo: item?.logo?.id ?? null,
    playDate: item?.playDate ?? "",
    status: typeof item?.status === "boolean" ? item.status : true,
  };

  return (
    <Modal show={show} handleClose={close} title={title}>
      <Formik
        initialValues={initialValues}
        onSubmit={async (values, { setSubmitting }) => {
          await submit(values, item.id);
          close();
          setSubmitting(false);
        }}
        enableReinitialize
      >
        {({ isSubmitting, dirty }) => (
          <Form>
            <div className="modal-body gap-y-3">
              <div className="intro-x grid md:grid-cols-2 md:gap-3">
                <Field
                  label="عنوان برنامه"
                  name="title"
                  component={TextField}
                  placeholder="مثلاً برنامه ورزشی"
                />

                <Field
                  label="شبکه:"
                  name="channel"
                  component={Select}
                  options={core?.channels || []}
                />

                <Field
                  label="تاریخ پخش:"
                  name="playDate"
                  component={PersianDataPicker}
                  hasTime={true}
                />

                <Field label="فعال باشد؟" name="status" component={CheckBox} />

                <Field
                  label="مدیا"
                  name="media"
                  dataType="id"
                  component={GalleryField}
                />

                <Field
                  label="لوگو"
                  name="logo"
                  dataType="id"
                  component={GalleryField}
                />
              </div>
            </div>

            <div className="modal-footer text-right">
              <button
                className="btn btn-primary w-20"
                type="submit"
                disabled={!!(isSubmitting || !dirty)}
              >
                {isSubmitting ? <Loading /> : "ذخیره"}
              </button>
              <button
                type="button"
                disabled={isSubmitting}
                onClick={close}
                className="btn btn-outline-secondary w-20 mr-1"
              >
                انصراف
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}
